export default __webpack_public_path__ + "static/media/Toledo.d2864586.jpeg";